/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does my synthesis sheet differ slightly?`)
};

const es_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mi hoja de síntesis difiere ligeramente?`)
};

const de_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum weicht mein Synthese-Datenblatt leicht ab?`)
};

const nl_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom wijkt mijn synthesespecificatieblad enigszins af?`)
};

const fr_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi ma fiche de synthèse diffère-t-elle légèrement ?`)
};

const it_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il mio foglio di sintesi differisce leggermente?`)
};

const pt_br2_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que minha ficha de síntese difere ligeiramente?`)
};

const pt_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque difere ligeiramente a minha ficha de síntese?`)
};

const ja_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合成仕様書とわずかに異なるのはなぜですか？`)
};

const zh_dnamw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我的合成规格单上的数值略有不同？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_q3", locale)
	if (locale === "en") return en_dnamw_faq_q3(inputs)
	if (locale === "es") return es_dnamw_faq_q3(inputs)
	if (locale === "de") return de_dnamw_faq_q3(inputs)
	if (locale === "nl") return nl_dnamw_faq_q3(inputs)
	if (locale === "fr") return fr_dnamw_faq_q3(inputs)
	if (locale === "it") return it_dnamw_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_q3(inputs)
	if (locale === "pt") return pt_dnamw_faq_q3(inputs)
	if (locale === "ja") return ja_dnamw_faq_q3(inputs)
	return zh_dnamw_faq_q3(inputs)
};